// Equipment bonus stat options — English keys, labels via i18n data.stats.*

export const BONUS_STAT_OPTIONS = [
  { value: 'AC',      label: 'Armor Class (AC)' },
  { value: 'INIT',    label: 'Initiative' },
  { value: 'SPD',     label: 'Speed' },
  { value: 'HP',      label: 'Max HP' },
  { value: 'STR',     label: 'Strength (STR)' },
  { value: 'DEX',     label: 'Dexterity (DEX)' },
  { value: 'CON',     label: 'Constitution (CON)' },
  { value: 'INT',     label: 'Intelligence (INT)' },
  { value: 'WIS',     label: 'Wisdom (WIS)' },
  { value: 'CHA',     label: 'Charisma (CHA)' },
  { value: 'SAV-STR', label: 'ST Strength' },
  { value: 'SAV-DEX', label: 'ST Dexterity' },
  { value: 'SAV-CON', label: 'ST Constitution' },
  { value: 'SAV-INT', label: 'ST Intelligence' },
  { value: 'SAV-WIS', label: 'ST Wisdom' },
  { value: 'SAV-CHA', label: 'ST Charisma' },
  { value: 'SK-ACR',  label: 'Acrobatics' },
  { value: 'SK-ANH',  label: 'Animal Handling' },
  { value: 'SK-ARC',  label: 'Arcana' },
  { value: 'SK-ATH',  label: 'Athletics' },
  { value: 'SK-DEC',  label: 'Deception' },
  { value: 'SK-HIS',  label: 'History' },
  { value: 'SK-INS',  label: 'Insight' },
  { value: 'SK-ITM',  label: 'Intimidation' },
  { value: 'SK-INV',  label: 'Investigation' },
  { value: 'SK-MED',  label: 'Medicine' },
  { value: 'SK-NAT',  label: 'Nature' },
  { value: 'SK-PER',  label: 'Perception' },
  { value: 'SK-PRF',  label: 'Performance' },
  { value: 'SK-PRS',  label: 'Persuasion' },
  { value: 'SK-REL',  label: 'Religion' },
  { value: 'SK-SLH',  label: 'Sleight of Hand' },
  { value: 'SK-STL',  label: 'Stealth' },
  { value: 'SK-SUR',  label: 'Survival' },
];
